import type { Skill } from '../skillsData';

export const cryptoskillAnalyticsExtraCData: Skill[] = [
  {
    id: 'pyth-price-agent',
    name: 'pyth-price-agent',
    author: 'Pyth Network',
    authorHandle: '@pythnetwork',
    tag: 'Skill',
    category: 'analytics',
    description: 'Pyth price agent. Autonomous price-feed monitoring, threshold alerts, and on-demand price proof generation across 500+ Pyth oracle feeds.',
    downloads: 14200,
    stars: 710,
    version: '1.0.0',
    installCommand: '> install the pyth-price-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/pyth-price-agent',
    usageExample: '> monitor pyth price feeds\n> set price alert\n> generate price proof',
    detailedDescription: 'Pyth price agent for autonomous price-feed monitoring. Set threshold alerts on any of 500+ Pyth oracle feeds, generate on-demand price proofs, and integrate real-time price data into AI agent workflows.',
    trending: true,
  },
  {
    id: 'pyth-price-feeds-mcp',
    name: 'pyth-price-feeds-mcp',
    author: 'Pyth Network',
    authorHandle: '@pythnetwork',
    tag: 'Skill',
    category: 'analytics',
    description: 'Pyth price feeds MCP server. Full Pyth oracle feed access via Model Context Protocol — prices, confidence intervals, and EMA prices for AI agents.',
    downloads: 18400,
    stars: 920,
    version: '1.0.0',
    installCommand: '> install the pyth-price-feeds-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/pyth-price-feeds-mcp',
    usageExample: '> query pyth feeds via MCP\n> get confidence interval\n> fetch EMA price',
    detailedDescription: 'Pyth price feeds Model Context Protocol server providing full oracle data — real-time prices, confidence intervals, exponential moving averages, and historical data — via standardized MCP interfaces for seamless AI integration.',
    featured: true,
  },
  {
    id: 'quanta-bot',
    name: 'quanta-bot',
    author: 'Quanta Labs',
    authorHandle: '@quantalabs',
    tag: 'Skill',
    category: 'analytics',
    description: 'Quanta Bot analytics. Quantitative market analysis, statistical arbitrage signals, and machine-learning-driven market regime detection.',
    downloads: 8600,
    stars: 430,
    version: '1.0.0',
    installCommand: '> install the quanta-bot skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/quanta-bot',
    usageExample: '> run quant analysis\n> generate arb signals\n> detect market regime',
    detailedDescription: 'Quanta Bot quantitative analytics platform. Run statistical arbitrage signal generation, detect market regime changes using ML models, and perform advanced quantitative market analysis across crypto assets.',
  },
  {
    id: 'quantaBot-defi-analytics',
    name: 'quantaBot-defi-analytics',
    author: 'Quanta Labs',
    authorHandle: '@quantalabs',
    tag: 'Skill',
    category: 'analytics',
    description: 'QuantaBot DeFi analytics. TVL attribution, yield optimization signals, and DeFi protocol performance benchmarking via quantitative models.',
    downloads: 6800,
    stars: 340,
    version: '1.0.0',
    installCommand: '> install the quantaBot-defi-analytics skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/quantaBot-defi-analytics',
    usageExample: '> attribute TVL sources\n> optimize yield signals\n> benchmark protocols',
    detailedDescription: 'QuantaBot DeFi-focused analytics providing TVL source attribution, yield optimization signal generation, and rigorous quantitative protocol performance benchmarking across DeFi ecosystems.',
  },
  {
    id: 'quantaBot',
    name: 'quantaBot',
    author: 'Quanta Labs',
    authorHandle: '@quantalabs',
    tag: 'Skill',
    category: 'analytics',
    description: 'QuantaBot core. Quantitative trading signals, portfolio risk analytics, and automated market intelligence for institutional-grade crypto research.',
    downloads: 9200,
    stars: 460,
    version: '1.0.0',
    installCommand: '> install the quantaBot skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/quantaBot',
    usageExample: '> generate trading signals\n> analyze portfolio risk\n> run market intelligence',
    detailedDescription: 'QuantaBot core quantitative intelligence engine. Generate institutional-grade trading signals, perform portfolio risk decomposition, and automate market intelligence gathering for advanced crypto research workflows.',
    trending: true,
  },
  {
    id: 'quantabot',
    name: 'quantabot',
    author: 'QuantaBot Community',
    authorHandle: '@quantabot_community',
    tag: 'Skill',
    category: 'analytics',
    description: 'Quantabot community edition. Open-source quantitative analytics, backtest framework integration, and community-driven market signal sharing.',
    downloads: 7400,
    stars: 370,
    version: '1.0.0',
    installCommand: '> install the quantabot skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/quantabot',
    usageExample: '> run community strategies\n> backtest signals\n> share market signals',
    detailedDescription: 'Quantabot community open-source edition. Access community-contributed quantitative strategies, run strategy backtests against historical data, and share market signal insights in the collaborative analytics ecosystem.',
  },
  {
    id: 'quantiva-intelligence',
    name: 'quantiva-intelligence',
    author: 'Quantiva',
    authorHandle: '@quantiva',
    tag: 'Skill',
    category: 'analytics',
    description: 'Quantiva intelligence platform. AI-enhanced quantitative research, cross-asset correlation analysis, and risk-adjusted signal generation for crypto portfolios.',
    downloads: 5600,
    stars: 280,
    version: '1.0.0',
    installCommand: '> install the quantiva-intelligence skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/quantiva-intelligence',
    usageExample: '> run quantiva research\n> analyze correlations\n> generate risk-adjusted signals',
    detailedDescription: 'Quantiva AI-enhanced intelligence platform for quantitative crypto research. Perform cross-asset correlation analysis, generate risk-adjusted trading signals, and apply machine learning models to institutional-grade portfolio analytics.',
  },
  {
    id: 'quantum-bot-defi',
    name: 'quantum-bot-defi',
    author: 'Quantum DeFi',
    authorHandle: '@quantum_defi',
    tag: 'Skill',
    category: 'analytics',
    description: 'Quantum Bot DeFi. Advanced DeFi analytics, impermanent loss optimization, and liquidity mining strategy evaluation using quantum-inspired algorithms.',
    downloads: 6200,
    stars: 310,
    version: '1.0.0',
    installCommand: '> install the quantum-bot-defi skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/quantum-bot-defi',
    usageExample: '> optimize impermanent loss\n> evaluate LM strategies\n> run quantum-inspired analysis',
    detailedDescription: 'Quantum Bot DeFi analytics applying quantum-inspired optimization algorithms to impermanent loss minimization, liquidity mining strategy evaluation, and advanced DeFi position management.',
  },
  {
    id: 'redstone-agent',
    name: 'redstone-agent',
    author: 'RedStone Finance',
    authorHandle: '@redstone_defi',
    tag: 'Skill',
    category: 'analytics',
    description: 'RedStone oracle agent. Autonomous price data verification, cross-oracle price deviation detection, and RedStone feed monitoring for DeFi protocols.',
    downloads: 11200,
    stars: 560,
    version: '1.0.0',
    installCommand: '> install the redstone-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/redstone-agent',
    usageExample: '> verify redstone prices\n> detect oracle deviations\n> monitor feed health',
    detailedDescription: 'RedStone oracle agent for autonomous price data verification. Monitor RedStone oracle feed health, detect cross-oracle price deviations, and automate DeFi protocol price data integrity checks.',
    trending: true,
  },
  {
    id: 'redstone-price-agent',
    name: 'redstone-price-agent',
    author: 'RedStone Finance',
    authorHandle: '@redstone_defi',
    tag: 'Skill',
    category: 'analytics',
    description: 'RedStone price agent. Real-time RedStone oracle price streaming, multi-asset price aggregation, and on-demand price data delivery for AI agents.',
    downloads: 8600,
    stars: 430,
    version: '1.0.0',
    installCommand: '> install the redstone-price-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/redstone-price-agent',
    usageExample: '> stream redstone prices\n> aggregate multi-asset prices\n> deliver price data on-demand',
    detailedDescription: 'RedStone price agent providing real-time oracle price streaming across 1,200+ data feeds. Aggregate multi-asset prices, deliver on-demand price data with cryptographic proofs to AI agent decision systems.',
  },
  {
    id: 'redstone-price-oracle',
    name: 'redstone-price-oracle',
    author: 'RedStone Finance',
    authorHandle: '@redstone_defi',
    tag: 'Skill',
    category: 'analytics',
    description: 'RedStone price oracle MCP. Full RedStone oracle suite via Model Context Protocol — data packages, historical prices, and cross-chain availability.',
    downloads: 12400,
    stars: 620,
    version: '1.0.0',
    installCommand: '> install the redstone-price-oracle skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/redstone-price-oracle',
    usageExample: '> query redstone oracle via MCP\n> get data packages\n> check cross-chain prices',
    detailedDescription: 'RedStone price oracle MCP integration exposing the full oracle suite through standardized interfaces. Access data packages, historical price records, cross-chain price availability, and cryptographic attestations for DeFi integrations.',
    featured: true,
  },
  {
    id: 'rug-slayer',
    name: 'rug-slayer',
    author: 'Rug Slayer',
    authorHandle: '@rugslayer',
    tag: 'Skill',
    category: 'analytics',
    description: 'Rug Slayer security scanner. Automated rug-pull detection, contract honeypot identification, liquidity lock verification, and team wallet monitoring.',
    downloads: 24600,
    stars: 1230,
    version: '2.0.0',
    installCommand: '> install the rug-slayer skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/rug-slayer',
    usageExample: '> scan for rug pull\n> check honeypot\n> verify liquidity lock',
    detailedDescription: 'Rug Slayer comprehensive security scanner detecting rug-pull patterns, honeypot contracts, liquidity manipulation, and suspicious team wallet activity across EVM chains with real-time risk scoring.',
    featured: true,
    trending: true,
  },
  {
    id: 'sai-market-intel',
    name: 'sai-market-intel',
    author: 'SAI Market Intel',
    authorHandle: '@sai_intel',
    tag: 'Skill',
    category: 'analytics',
    description: 'SAI market intelligence. AI-powered news aggregation, market-moving event detection, and narrative sentiment analysis for crypto markets.',
    downloads: 7200,
    stars: 360,
    version: '1.0.0',
    installCommand: '> install the sai-market-intel skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/sai-market-intel',
    usageExample: '> aggregate crypto news\n> detect market events\n> analyze narratives',
    detailedDescription: 'SAI market intelligence platform aggregating news and events from 500+ crypto sources. Use AI to detect market-moving events early, analyze narrative sentiment shifts, and correlate news signals with on-chain data.',
  },
  {
    id: 'scambuster-v2',
    name: 'scambuster-v2',
    author: 'ScamBuster',
    authorHandle: '@scambuster',
    tag: 'Skill',
    category: 'analytics',
    description: 'ScamBuster v2. Advanced scam detection for tokens, wallets, and smart contracts. Combines ML risk models, community reports, and on-chain evidence.',
    downloads: 18600,
    stars: 930,
    version: '2.0.0',
    installCommand: '> install the scambuster-v2 skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/scambuster-v2',
    usageExample: '> scan token for scam\n> check wallet reputation\n> verify contract safety',
    detailedDescription: 'ScamBuster v2 advanced scam detection engine combining machine learning risk models, community-sourced scam reports, and on-chain evidence analysis to protect users from malicious tokens, wallets, and smart contracts.',
    featured: true,
    trending: true,
  },
  {
    id: 'sibyl-crypto-intel',
    name: 'sibyl-crypto-intel',
    author: 'Sibyl Intelligence',
    authorHandle: '@sibyl_intel',
    tag: 'Skill',
    category: 'analytics',
    description: 'Sibyl crypto intelligence. Predictive market analytics, early trend identification, and whale behavior prediction using advanced ML forecasting models.',
    downloads: 8400,
    stars: 420,
    version: '1.0.0',
    installCommand: '> install the sibyl-crypto-intel skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/sibyl-crypto-intel',
    usageExample: '> predict market trends\n> identify early trends\n> forecast whale behavior',
    detailedDescription: 'Sibyl crypto intelligence using advanced machine learning forecasting to predict market trends, identify emerging narratives early, and model whale wallet behavior patterns for predictive analytics.',
  },
  {
    id: 'sibyl-crypto-intelligence',
    name: 'sibyl-crypto-intelligence',
    author: 'Sibyl Intelligence',
    authorHandle: '@sibyl_intel',
    tag: 'Skill',
    category: 'analytics',
    description: 'Sibyl crypto intelligence full suite. Complete predictive analytics including price forecasting, sentiment modeling, and macro correlation analysis.',
    downloads: 6800,
    stars: 340,
    version: '1.0.0',
    installCommand: '> install the sibyl-crypto-intelligence skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/sibyl-crypto-intelligence',
    usageExample: '> forecast prices\n> model sentiment\n> analyze macro correlations',
    detailedDescription: 'Sibyl complete intelligence suite combining price forecasting models, sentiment trajectory analysis, and macro market correlation mapping for comprehensive predictive crypto analytics.',
  },
  {
    id: 'social-sentiment-agent',
    name: 'social-sentiment-agent',
    author: 'Social Sentiment',
    authorHandle: '@social_sentiment',
    tag: 'Skill',
    category: 'analytics',
    description: 'Social sentiment agent. Real-time social media sentiment tracking across Twitter/X, Reddit, Telegram, and Discord for 1000+ crypto tokens.',
    downloads: 22400,
    stars: 1120,
    version: '1.0.0',
    installCommand: '> install the social-sentiment-agent skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/social-sentiment-agent',
    usageExample: '> track token sentiment\n> monitor social mentions\n> detect sentiment shifts',
    detailedDescription: 'Social sentiment agent aggregating real-time sentiment signals from Twitter/X, Reddit, Telegram, Discord, and Farcaster for 1000+ crypto tokens. Detect early sentiment shifts and correlate with price movements.',
    featured: true,
    trending: true,
  },
  {
    id: 'subgraph-registry',
    name: 'subgraph-registry',
    author: 'The Graph',
    authorHandle: '@graphprotocol',
    tag: 'Skill',
    category: 'analytics',
    description: 'Subgraph registry skill. Discover and query The Graph protocol subgraphs, access indexed blockchain data, and build custom analytics dashboards.',
    downloads: 16800,
    stars: 840,
    version: '1.0.0',
    installCommand: '> install the subgraph-registry skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/subgraph-registry',
    usageExample: '> discover subgraphs\n> query indexed data\n> build analytics dashboard',
    detailedDescription: 'The Graph subgraph registry integration. Discover relevant subgraphs across 40+ supported chains, query indexed blockchain data via GraphQL, and build custom analytics dashboards on top of The Graph\'s decentralized indexing network.',
    featured: true,
  },
  {
    id: 'surf-official',
    name: 'surf-official',
    author: 'Surf Protocol',
    authorHandle: '@surfprotocol',
    tag: 'Skill',
    category: 'analytics',
    description: 'Official Surf Protocol analytics. On-chain social analytics, content engagement metrics, and Web3 creator economy intelligence.',
    downloads: 5200,
    stars: 260,
    version: '1.0.0',
    installCommand: '> install the surf-official skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/surf-official',
    usageExample: '> analyze on-chain social\n> track content engagement\n> monitor creator economy',
    detailedDescription: 'Official Surf Protocol analytics for on-chain social platforms. Track content engagement metrics, analyze creator economy activity, and monitor Web3 social interactions across decentralized social networks.',
  },
  {
    id: 'sys84-intelligence',
    name: 'sys84-intelligence',
    author: 'Sys84',
    authorHandle: '@sys84',
    tag: 'Skill',
    category: 'analytics',
    description: 'Sys84 intelligence platform. Dark web monitoring, threat intelligence feeds, and blockchain forensics for comprehensive crypto security analysis.',
    downloads: 4800,
    stars: 240,
    version: '1.0.0',
    installCommand: '> install the sys84-intelligence skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/sys84-intelligence',
    usageExample: '> monitor dark web\n> access threat intel\n> run blockchain forensics',
    detailedDescription: 'Sys84 advanced intelligence platform combining dark web monitoring, curated threat intelligence feeds, and blockchain forensics to provide comprehensive crypto security intelligence for enterprise and institutional users.',
  },
  {
    id: 'technical-expert',
    name: 'technical-expert',
    author: 'Technical Expert',
    authorHandle: '@technical_expert',
    tag: 'Skill',
    category: 'analytics',
    description: 'Technical Expert analytics agent. Advanced technical analysis, chart pattern automation, indicator computation, and trading signal aggregation.',
    downloads: 11200,
    stars: 560,
    version: '1.0.0',
    installCommand: '> install the technical-expert skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/technical-expert',
    usageExample: '> run technical analysis\n> automate chart patterns\n> aggregate trading signals',
    detailedDescription: 'Technical Expert analytics agent automating advanced technical analysis. Compute 50+ indicators, detect chart patterns using computer vision, and aggregate multiple trading signals into unified market assessments.',
    trending: true,
  },
  {
    id: 'the-swarm-slamai',
    name: 'the-swarm-slamai',
    author: 'The Swarm',
    authorHandle: '@theswarm_ai',
    tag: 'Skill',
    category: 'analytics',
    description: 'The Swarm SLAM AI. Decentralized intelligence network — aggregate insights from a swarm of specialized analytics agents into unified market intelligence.',
    downloads: 7600,
    stars: 380,
    version: '1.0.0',
    installCommand: '> install the the-swarm-slamai skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/the-swarm-slamai',
    usageExample: '> query swarm intelligence\n> aggregate agent insights\n> get unified market intel',
    detailedDescription: 'The Swarm SLAM AI decentralized intelligence aggregation system. Coordinate a swarm of specialized analytics agents, aggregate their individual market insights, and synthesize unified intelligence reports from collective AI analysis.',
  },
  {
    id: 'the-watcher-sees',
    name: 'the-watcher-sees',
    author: 'The Watcher',
    authorHandle: '@thewatcher',
    tag: 'Skill',
    category: 'analytics',
    description: 'The Watcher Sees omniscient analytics. 24/7 on-chain surveillance — monitor wallets, contracts, and protocols simultaneously with AI anomaly detection.',
    downloads: 9800,
    stars: 490,
    version: '1.0.0',
    installCommand: '> install the the-watcher-sees skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/the-watcher-sees',
    usageExample: '> start watcher surveillance\n> detect on-chain anomalies\n> monitor multiple targets',
    detailedDescription: 'The Watcher Sees 24/7 omniscient on-chain surveillance system. Simultaneously monitor hundreds of wallets, smart contracts, and DeFi protocols with AI-powered anomaly detection, pattern recognition, and real-time alert delivery.',
    trending: true,
  },
  {
    id: 'thegraph-mcp',
    name: 'thegraph-mcp',
    author: 'The Graph',
    authorHandle: '@graphprotocol',
    tag: 'Skill',
    category: 'analytics',
    description: 'The Graph MCP server. Model Context Protocol access to The Graph decentralized indexing — query any subgraph via natural language or GraphQL.',
    downloads: 14200,
    stars: 710,
    version: '1.0.0',
    installCommand: '> install the thegraph-mcp skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/thegraph-mcp',
    usageExample: '> query subgraph via MCP\n> natural language GraphQL\n> access indexed blockchain data',
    detailedDescription: 'The Graph Model Context Protocol server exposing decentralized subgraph indexing via standardized MCP interfaces. Query any deployed subgraph using natural language or raw GraphQL across 40+ supported blockchain networks.',
    featured: true,
    trending: true,
  },
  {
    id: 'token-safety-scanner',
    name: 'token-safety-scanner',
    author: 'Token Safety',
    authorHandle: '@tokensafety',
    tag: 'Skill',
    category: 'analytics',
    description: 'Token Safety Scanner. Comprehensive token safety checks — contract audit history, ownership risk, trading restrictions, liquidity analysis, and holder concentration.',
    downloads: 28600,
    stars: 1430,
    version: '2.0.0',
    installCommand: '> install the token-safety-scanner skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/token-safety-scanner',
    usageExample: '> scan token safety\n> check audit history\n> analyze holder concentration',
    detailedDescription: 'Comprehensive token safety scanner checking contract audit history, ownership risks, trading restrictions (buy/sell taxes, blacklists), liquidity lock status, and holder concentration for complete token safety assessment.',
    featured: true,
    trending: true,
  },
  {
    id: 'token-unlock-schedule',
    name: 'token-unlock-schedule',
    author: 'Token Unlock',
    authorHandle: '@tokenunlock',
    tag: 'Skill',
    category: 'analytics',
    description: 'Token unlock schedule tracker. Upcoming token unlock calendars, vesting cliff alerts, and unlock impact analysis for 500+ tokens.',
    downloads: 16800,
    stars: 840,
    version: '1.0.0',
    installCommand: '> install the token-unlock-schedule skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/token-unlock-schedule',
    usageExample: '> check unlock calendar\n> set cliff alert\n> analyze unlock impact',
    detailedDescription: 'Token unlock schedule tracker providing upcoming vesting and unlock calendars for 500+ tokens. Receive cliff date alerts, analyze expected selling pressure from unlocks, and track cumulative unlocked supply over time.',
    featured: true,
  },
  {
    id: 'token-unlock-scheduler',
    name: 'token-unlock-scheduler',
    author: 'Token Unlock',
    authorHandle: '@tokenunlock',
    tag: 'Skill',
    category: 'analytics',
    description: 'Token unlock scheduler agent. Automated unlock event scheduling, customizable alert rules, and portfolio-level unlock impact modeling.',
    downloads: 11200,
    stars: 560,
    version: '1.0.0',
    installCommand: '> install the token-unlock-scheduler skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/token-unlock-scheduler',
    usageExample: '> schedule unlock alerts\n> set custom rules\n> model portfolio impact',
    detailedDescription: 'Token unlock scheduler agent for automated event management. Create customizable unlock alert rules, model portfolio-level selling pressure from upcoming unlocks, and automate trading strategy triggers based on unlock events.',
  },
  {
    id: 'token-unlock-tracker',
    name: 'token-unlock-tracker',
    author: 'Token Unlock',
    authorHandle: '@tokenunlock',
    tag: 'Skill',
    category: 'analytics',
    description: 'Token unlock tracker. Real-time on-chain unlock event monitoring, wallet-level vesting tracking, and price correlation analysis for token unlock events.',
    downloads: 14600,
    stars: 730,
    version: '1.0.0',
    installCommand: '> install the token-unlock-tracker skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/token-unlock-tracker',
    usageExample: '> track on-chain unlocks\n> monitor vesting wallets\n> correlate unlock with price',
    detailedDescription: 'Real-time token unlock tracker monitoring on-chain vesting contract events. Track individual wallet-level vesting progress, analyze historical price correlations with past unlock events, and predict future unlock selling pressure.',
    trending: true,
  },
  {
    id: 'txray-mev-analyzer',
    name: 'txray-mev-analyzer',
    author: 'TxRay',
    authorHandle: '@txray',
    tag: 'Skill',
    category: 'analytics',
    description: 'TxRay MEV analyzer. Transaction MEV extraction quantification, sandwich attack detection, frontrunning identification, and MEV bot tracking.',
    downloads: 12400,
    stars: 620,
    version: '1.0.0',
    installCommand: '> install the txray-mev-analyzer skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/txray-mev-analyzer',
    usageExample: '> quantify MEV extraction\n> detect sandwich attacks\n> track MEV bots',
    detailedDescription: 'TxRay MEV analysis platform. Quantify MEV extraction per transaction and block, detect sandwich attacks and frontrunning patterns, identify active MEV bots, and analyze MEV impact on DeFi protocol users.',
    trending: true,
  },
  {
    id: 'value-extraction',
    name: 'value-extraction',
    author: 'Value Extraction Labs',
    authorHandle: '@valueextract',
    tag: 'Skill',
    category: 'analytics',
    description: 'Value Extraction analytics. Protocol fee analysis, revenue attribution, value accrual modeling, and token buyback/burn impact assessment.',
    downloads: 6800,
    stars: 340,
    version: '1.0.0',
    installCommand: '> install the value-extraction skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/value-extraction',
    usageExample: '> analyze protocol fees\n> model value accrual\n> assess buyback impact',
    detailedDescription: 'Value Extraction analytics platform for protocol economic analysis. Decompose protocol fee flows, model value accrual to token holders, and assess the impact of token buyback and burn mechanisms on long-term token value.',
  },
  {
    id: 'whale-accumulation-scanner',
    name: 'whale-accumulation-scanner',
    author: 'Whale Scanner',
    authorHandle: '@whalescanner',
    tag: 'Skill',
    category: 'analytics',
    description: 'Whale accumulation scanner. Detect early whale accumulation patterns, track large wallet position building, and predict accumulation-driven price movements.',
    downloads: 19800,
    stars: 990,
    version: '1.0.0',
    installCommand: '> install the whale-accumulation-scanner skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/whale-accumulation-scanner',
    usageExample: '> scan whale accumulation\n> track large positions\n> predict price impact',
    detailedDescription: 'Whale accumulation scanner detecting early-stage large wallet position building. Identify stealth accumulation patterns across DeFi and CEX wallets, track large position construction over time, and generate accumulation-driven alpha signals.',
    featured: true,
    trending: true,
  },
  {
    id: 'x402-token-sentiment',
    name: 'x402-token-sentiment',
    author: 'x402 Protocol',
    authorHandle: '@x402protocol',
    tag: 'Skill',
    category: 'analytics',
    description: 'x402 token sentiment API. Paid sentiment data streams, real-time social signal APIs, and monetized market intelligence via the x402 payment protocol.',
    downloads: 7600,
    stars: 380,
    version: '1.0.0',
    installCommand: '> install the x402-token-sentiment skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/x402-token-sentiment',
    usageExample: '> access paid sentiment streams\n> query social signals\n> monetize market intel',
    detailedDescription: 'x402 token sentiment API providing monetized market intelligence via the x402 micropayment protocol. Access premium sentiment data streams, real-time social signal APIs, and pay-per-query market intelligence with sub-second data freshness.',
  },
  {
    id: 'zapper-api',
    name: 'zapper-api',
    author: 'Zapper',
    authorHandle: '@zapper_fi',
    tag: 'Skill',
    category: 'analytics',
    description: 'Zapper API integration. Portfolio tracking, DeFi position aggregation, transaction history, and NFT portfolio valuation across 20+ networks.',
    downloads: 24600,
    stars: 1230,
    version: '2.0.0',
    installCommand: '> install the zapper-api skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/zapper-api',
    usageExample: '> track portfolio via Zapper\n> aggregate DeFi positions\n> valuate NFT portfolio',
    detailedDescription: 'Zapper API integration providing comprehensive portfolio tracking across 20+ networks. Aggregate DeFi positions, retrieve detailed transaction histories, valuate NFT portfolios, and track yield farming performance.',
    featured: true,
  },
  {
    id: 'zapper',
    name: 'zapper',
    author: 'Zapper',
    authorHandle: '@zapper_fi',
    tag: 'Skill',
    category: 'analytics',
    description: 'Zapper core skill. All-in-one DeFi portfolio dashboard, position management, and cross-chain asset tracking powered by the Zapper data platform.',
    downloads: 36400,
    stars: 1820,
    version: '2.0.0',
    installCommand: '> install the zapper skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/zapper',
    usageExample: '> view DeFi dashboard\n> manage positions\n> track cross-chain assets',
    detailedDescription: 'Zapper core DeFi intelligence platform. Access the all-in-one portfolio dashboard, manage DeFi positions across protocols, and track cross-chain asset holdings with automatic position labeling and P&L attribution.',
    featured: true,
    trending: true,
  },
  {
    id: 'zerion-api-skill',
    name: 'zerion-api-skill',
    author: 'Zerion',
    authorHandle: '@zerion_io',
    tag: 'Skill',
    category: 'analytics',
    description: 'Zerion API skill. Portfolio analytics, DeFi position tracking, transaction decoding, and cross-chain balance aggregation via the Zerion API.',
    downloads: 22400,
    stars: 1120,
    version: '1.0.0',
    installCommand: '> install the zerion-api-skill skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/zerion-api-skill',
    usageExample: '> query Zerion portfolio\n> decode transactions\n> aggregate cross-chain balances',
    detailedDescription: 'Zerion API skill providing portfolio analytics, DeFi position tracking with automatic labeling, detailed transaction decoding, and cross-chain balance aggregation for 10,000+ tokens across 20+ networks.',
    featured: true,
  },
  {
    id: 'zerion-api',
    name: 'zerion-api',
    author: 'Zerion',
    authorHandle: '@zerion_io',
    tag: 'Skill',
    category: 'analytics',
    description: 'Zerion API core. Full Zerion data access for wallets, positions, transactions, and fungible/non-fungible assets across all supported chains.',
    downloads: 28600,
    stars: 1430,
    version: '1.0.0',
    installCommand: '> install the zerion-api skill from https://github.com/jiayaoqijia/cryptoskill/tree/main/skills/analytics/zerion-api',
    usageExample: '> query wallet data\n> get all positions\n> fetch transaction history',
    detailedDescription: 'Zerion API core integration providing full data access for wallets, DeFi positions, transaction histories, and fungible/non-fungible asset portfolios across all Zerion-supported blockchain networks.',
    featured: true,
    trending: true,
  },
];